/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState, useRef, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, Modal, IconButton, Popper } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './index.scss';
import Color from '@tool/color';
import { CloseIcon20, CloseIcon } from '@styled/icon';
import {
  DButton, EButton, SureButton, ChooseButton,
} from '../../../../component/styled/index';
import moIndex, {
  chooseIndustry, unChooseIndustry, chooseSubIndustry,
  multiSure, multiCancel, changeMulti, onChoose, onChoose1,
} from '../../store/index';

interface IProps {}
interface IState {}

const CButton = styled(DButton)(() => ({
  width: '100%',
  height: '36px',
}));

const DModal = styled(Modal)(() => ({
  zIndex: 5555555,
}));

const DPopper = styled(Popper)(() => ({
}));

const CloseIconButton = styled(IconButton)(() => ({
  position: 'absolute',
  top: 0,
  right: '-50px',
}));

const CancelButton = styled(Button)(() => ({
  height: '36px',
  width: '80px',
  marginRight: '10px',
  fontSize: '14px',
  borderRadius: '18px',
  color: Color.fff,
  backgroundColor: Color.blackColor(0.35),

  '&:hover': {
    color: Color.fff,
    backgroundColor: Color.blackColor(0.4),
  },
}));

const MultiIndustry = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const subRef = useRef(null);
  const {
    multiIndustry, currentMulti, industry, compareIndustry, multiModal,
  } = moIndex;

  useEffect(() => {
    return () => {};
  }, []);

  const onNothing = () => {};

  return (
    <DModal open={multiModal} onClose={() => onNothing()}>
      <section className="industry-modal_0110">
        <section className="title-015">
          <span>选择行业</span>
          <p className="line-1511">
            {/* <CancelButton onClick={() => multiCancel()}>取消</CancelButton> */}
            <SureButton ref={subRef} variant="contained" color="secondary"
              onClick={multiSure}>确定
            </SureButton>
          </p>
        </section>
        <section className="modal-0111">
          <section className="industry-0101">
            {multiIndustry.map((item: any, index: number) => (
              <section key={index} className="industry-0102">
                <CButton onClick={() => onChoose1(item.info.code, item.info.active)}
                  className={item.info.active ? 'active' : ''}>{item.info.name}
                </CButton>
              </section>
            ))}
          </section>
          <section className="industry-0201">
            {currentMulti.map((child: any, index: number) => (
              <section key={index} className="item-111">
                <EButton key={index} disabled={child.name === industry.name}
                  onClick={() => onChoose(child.code, child.active)}
                  className={child.active ? 'active' : ''}>{child.name}
                </EButton>
                {child.name === industry.name ? <p className="tip-111">
                  我所在的行业
                  <i className="tri-10" />
                </p> : null}
              </section>
            ))}
          </section>
        </section>
        <section className="modal-0113">
          {compareIndustry.map((item: any) => (
            <ChooseButton key={item.code}
              onClick={() => unChooseIndustry(item.code)}
              endIcon={
                compareIndustry.length > 1 ? <CloseIcon color={Color.primary} /> : null
              }>{item.name}
            </ChooseButton>
          ))}
        </section>
        {/* <CloseIconButton>
          <CloseIcon20 color={Color.fff} width={30} height={30} />
        </CloseIconButton> */}
      </section>
    </DModal>
  );
};

export default observer(MultiIndustry);
